const VIEWABLE_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png']

export const isFigureImageViewable = (filename: string | undefined): boolean => {
  if (!filename) {
    return false
  }
  const extension = filename.split('.').pop()?.toLowerCase()
  return extension !== undefined && VIEWABLE_IMAGE_EXTENSIONS.includes(extension)
}

export const getFigureImageUrl = (baseUri: string, figureId: number | string): string =>
  `${baseUri}figures/${figureId}/image`
